module.exports = __webpack_public_path__ + "img/02.a56e0f4c.png";